import { render, staticRenderFns } from "./MainArea.vue?vue&type=template&id=8e947db6&scoped=true&"
import script from "./MainArea.vue?vue&type=script&lang=js&"
export * from "./MainArea.vue?vue&type=script&lang=js&"
import style0 from "./MainArea.vue?vue&type=style&index=0&id=8e947db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e947db6",
  null
  
)

export default component.exports